import { AlignCenterOutlined } from "@ant-design/icons";
import React from "react";
import { Navigate, Outlet, redirect } from "react-router-dom";
import { useAuth } from "./AuthWrapper";

// check role user แยกตาม เมนู
const ProtectedRoute = ({ access, redirectPath = "/", children }) => {
  const auth = useAuth();

  if (!auth.user) {
    return <Navigate to={redirectPath} replace />;
  } else {
    const result =
      access &&
      access.filter((d) => {
        if (d == auth.user.role) {
          return d;
        }
      });
    if (result?.length == 0) {
      return <Navigate to={"/404"} replace />;
    }

    return children ? children : <Outlet />;
  }
};

export default ProtectedRoute;
